import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { LightbulbOutlined, Lightbulb } from '@mui/icons-material';
import { useThemeContext } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { isDarkMode, toggleTheme } = useThemeContext();
  const theme = useTheme();

  return (
    <Tooltip title={isDarkMode ? 'Light Mode aktivieren' : 'Dark Mode aktivieren'}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          p: 1.5,
          borderRadius: '50%',
          background: `linear-gradient(45deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
          border: `2px solid ${theme.palette.primary.main}30`,
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            background: `linear-gradient(45deg, ${theme.palette.primary.main}30, ${theme.palette.secondary.main}30)`,
            transform: 'scale(1.1) rotate(15deg)',
            border: `2px solid ${theme.palette.primary.main}50`,
            boxShadow: `0 4px 20px ${theme.palette.primary.main}30`,
          },
          '&:active': {
            transform: 'scale(0.95)',
          }
        }}
      >
        {isDarkMode ? (
          <LightbulbOutlined
            sx={{
              fontSize: 28,
              color: theme.palette.warning.main,
              filter: 'drop-shadow(0 0 8px rgba(255, 193, 7, 0.6))',
              transition: 'all 0.3s ease-in-out',
            }}
          />
        ) : (
          <Lightbulb
            sx={{
              fontSize: 28,
              color: theme.palette.warning.main,
              filter: 'drop-shadow(0 0 12px rgba(255, 193, 7, 0.8))',
              transition: 'all 0.3s ease-in-out',
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;